'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoGrid = function IoGrid(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 12c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-4c0-0.3 0.2-0.5 0.5-0.5h4c0.3 0 0.5 0.2 0.5 0.5v4z m10 0c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-4c0-0.3 0.2-0.5 0.5-0.5h4c0.3 0 0.5 0.2 0.5 0.5v4z m10 0c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-4c0-0.3 0.2-0.5 0.5-0.5h4c0.3 0 0.5 0.2 0.5 0.5v4z m-20 10c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-4c0-0.3 0.2-0.5 0.5-0.5h4c0.3 0 0.5 0.2 0.5 0.5v4z m10 0c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-4c0-0.3 0.2-0.5 0.5-0.5h4c0.3 0 0.5 0.2 0.5 0.5v4z m10 0c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-4c0-0.3 0.2-0.5 0.5-0.5h4c0.3 0 0.5 0.2 0.5 0.5v4z m-20 10c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-4c0-0.3 0.2-0.5 0.5-0.5h4c0.3 0 0.5 0.2 0.5 0.5v4z m10 0c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-4c0-0.3 0.2-0.5 0.5-0.5h4c0.3 0 0.5 0.2 0.5 0.5v4z m10 0c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-4c0-0.3 0.2-0.5 0.5-0.5h4c0.3 0 0.5 0.2 0.5 0.5v4z' })
        )
    );
};

exports.default = IoGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/grid.js
// module id = 2519
// module chunks = 168707334958949